import apply from './apply'; // 我要申请
/**
 * 登记办理路由配置
 */
export default {
  path: '/home/check-in',
  name: 'check-in',
  component: () => import('iebdc/views/check-in'),
  meta: {
    label: '登记办理',
    permission: 'IEBDC:SY:DJBL',
    construction: 'IEBDC:SY:DJBL:SFZJ'
  },
  redirect: '/home/check-in/registrationFor',
  children: [
    {
      path: '/home/check-in/registrationFor',
      name: 'registrationFor',
      component: () => import('iebdc/views/apply/flow/registrationFor'),
      meta: {
        label: '在线登记',
        icon: 'document',
        isNotMenu: true,
        activeMenu: '/home/check-in',
        permission: 'IEBDC:GNXS:SY'
      }
    },
    apply
  ]
};
